// function NewsBox({ image, author, title, description, story, publishedAt, url }) {
//     return (
//         <div classNameName="column">
//             <div classNameName="newsimg">
//                 <img src={image} alt="" />
//             </div>
//             <div classNameName="con">
//                 <h2 classNameName='title'>{title}</h2>
//                 <p classNameName="description">{story}</p>
//             </div>
//             <div classNameName="foot">
//                 <h3 classNameName="author">By-{author}</h3>
//                 <a href={url} classNameName="footbtn" target="_blank" rel="noopener noreferrer">
//                     <button classNameName='btn'>read</button>
//                 </a>
//             </div >
//         </div >
//     );
// }

function NewsBox({
  image,
  author,
  title,
  description,
  story,
  publishedAt,
  url,
}) {
  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  function truncateText(text, maxLength) {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...';
    }
    return text;
  }
  const handleCardClick = (e) => {
    // Prevent the card click if the button is clicked
    if (e.target.tagName.toLowerCase() === 'a') {
      return;
    }
    window.open(url, '_blank');
  };
  return (

    <div  onClick={handleCardClick}  className="xl:w-1/4 md:w-1/3 sm:w-1/2 w-full p-4 ">
      <div className="p-4 rounded-lg text-white shadow-md transition-transform transform hover:scale-105 h-full bg-card">
        <img
          className="h-32 rounded w-full object-cover object-center mb-2"
          src={image}
          alt="News"
        />
        <h3 className="mt-5 tracking-widest text-indigo-500 text-sx font-medium title-font mb-1">
          <b className="text-write2">{author}</b> - {formatDate(publishedAt)}
        </h3>
        <h2 className="text-xl font-bold mb-2 truncate">
          {title}
        </h2>
        <p className="leading-relaxed text-sm mb-2 line-clamp-4">{truncateText(story, 130)}<a 
          href={url} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="float-right hover:scale-105 "
        >
          Read More...
        </a></p>
        
      </div>
    </div>
  );
}

export default NewsBox;
